import { render, staticRenderFns } from "./seedList.vue?vue&type=template&id=d966a1b4&scoped=true"
import script from "./seedList.vue?vue&type=script&lang=js"
export * from "./seedList.vue?vue&type=script&lang=js"
import style0 from "./seedList.vue?vue&type=style&index=0&id=d966a1b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d966a1b4",
  null
  
)

export default component.exports